import { useMutation } from 'react-query'
import request from '../../../request'
import { useDealership } from '../../../../store/zustand/dealershipStore'

export const usePostCreateLaunchLabsConnection = () => {
  const dealership = useDealership()
  return useMutation(
    ({
      data,
    }: {
      data: { launchlabs_api_key: string; launchlabs_api_token: string }
    }) => {
      return request<{ leadsUrl: string }>({
        method: 'POST',
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/settings/integrations/launchlabs/connect`,
        data,
      })
    },
  )
}
